<div class="col-md-12 action-buttons text-right gen-button">
    <div class="gen-input">
        <button [buttonBusy]="renderingPassword" [disabled]="disablePasswordGenerationButton" (click)="generatePassword()" class="btn btn-primary">{{l(actionButtonStructure.componentSettings.actionButtonLabelKey)}}</button>
        <input [(ngModel)]="generatedPassword" [disabled]="passwordNotGenerated" readonly kendoTextBox />
    </div>
    <div class="temp-pw-info">{{l("TemporaryPasswordInfo")}}</div>
</div>